<template>
  <div class="login-wrap">
    <div class="login-child">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
        class="demo-ruleForm login-container">
        <!-- <h3 class="title">用户登录</h3> -->
        <el-form-item prop="username">
          <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="15">
            <el-form-item prop="code">
              <el-input type="text" v-model="ruleForm.code" auto-complete="off" placeholder="图形验证码"
                @keyup.enter.native="submitForm('ruleForm')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9" class="code-box">
            <!-- <img :src="ruleForm.codeimg" alt class="codeimg" @click="getcode()" /> -->
            <img :src="ruleForm.identify" style="width: 100px; height: 38px" @click="getLogin()" />
            <!-- src=" -->
          </el-col>
        </el-row>
        <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
        <el-form-item style="width: 50%">
          <el-button type="primary" style="width: 200%" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { login, user_pass, login_auth } from "../api/login/api";
export default {
  name: "login",
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
        code: "",
        randomStr: "",
        token: "",
        identify: "",
        sk: "",
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { len: 4, message: "请输入4位验证码", trigger: "blur" },
        ],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getLogin();
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取用户名密码
    getLogin() {
      login().then((res) => {
        if (res["code"] === 0) {
          this.ruleForm.token = res.data.token;
          this.ruleForm.sk = res.data.sk;
          this.ruleForm.identify = res.data.identify;
          window.localStorage.setItem("yypt_web_token", this.ruleForm.token);
          window.localStorage.setItem("yypt_web_sk", this.ruleForm.sk);
        }
      });
    },
    getAuth() {
      login_auth().then((res) => {
        window.localStorage.setItem("auth_self", res.data)
        if (res.data == "") {
          this.$router.push({ path: "/user_mn/User_mn" });
        } else {
          this.$router.push({ path: "/home_page/home_Page" });
        }
      })
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          user_pass(this.ruleForm).then((res) => {
            if (res["code"] === 0) {
              this.logining = false;
              this.$store.commit("login", "true");
              localStorage.setItem("yypt_web_user", this.ruleForm.username);
              this.getAuth()
            } else if (res["message"] == "密码错误") {
              this.ruleForm.password = "";
              this.ruleForm.code = "";
              this.getLogin();
              this.logining = false;
            } else if (res["message"] == "验证码错误") {
              this.ruleForm.code = "";
              this.getLogin();
              this.logining = false;
            } else {
              this.ruleForm.username = "";
              this.ruleForm.password = "";
              this.ruleForm.code = "";
              this.getLogin();
              this.logining = false;
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  background-image: url("~@/assets/img/bg1.png");
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: cover;
}

.login-child {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  /* margin: 0px auto; */
  width: 600px;
  padding: 100px 0px 50px 175px;
  /* background: rgba(0, 0, 0, 0.01); */
  background: url("~@/assets/img/login.png") no-repeat;
  background-size: 750px;
}

.login-container {
  /* position: absolute;
  left: 35%;
  top: 30%; */

  width: 400px;
  border-radius: 10px;


}

.remember {
  margin: 0px 0px 15px 0px;
  color: #eaeaea;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}

.el-input /deep/ .el-input__inner {
  margin-bottom: 5px;
  background-color: rgba(255, 255, 255, 0.247);
  color: #eaeaea;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue